import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { DialogService } from 'primeng/dynamicdialog';
import { BreadcrumbService } from '../../core/services/breadcrumb.service';
import { SystemDialogService } from '../../core/services/system-dialog.service';
import { ToastService } from '../../core/services/toast.service';
import { AppConfig } from './../../config/app.config';

/**
 * @description 提供基礎注入 services
 */
export abstract class BaseComponent {
  /**
   * @description NGXLogger service
   */
  logger: NGXLogger;
  /**
   * @description 翻譯 service
   */
  translateService: TranslateService;
  /**
   * @description 麵包屑 service
   */
  breadcrumbService: BreadcrumbService;
  /**
   * @description Toast 顯示 service
   */
  toastService: ToastService;
  /**
   * @description 系統 dialog 顯示 service
   */
  dialogService: SystemDialogService;
  /**
   * @description primeng dynamic DialogService, 可自訂顯示 component
   */
  dialog: DialogService;
  /**
   * @description env.json 設定, 包含 api url、國家代碼、格式化(日期)…等
   */
  appConfig: AppConfig;

  /**
   * constructor.
   *
   * @param angular injector
   */
  constructor(injector: Injector) {
    this.logger = injector.get(NGXLogger);
    this.translateService = injector.get(TranslateService);
    this.breadcrumbService = injector.get(BreadcrumbService);
    this.toastService = injector.get(ToastService);
    this.dialogService = injector.get(SystemDialogService);
    this.dialog = injector.get(DialogService);
    this.appConfig = injector.get(AppConfig);
  }
}
